import { render, staticRenderFns } from "./sendtypesetting.vue?vue&type=template&id=8e85b166"
import script from "./sendtypesetting.vue?vue&type=script&lang=js"
export * from "./sendtypesetting.vue?vue&type=script&lang=js"
import style0 from "./sendtypesetting.vue?vue&type=style&index=0&id=8e85b166&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e85b166')) {
      api.createRecord('8e85b166', component.options)
    } else {
      api.reload('8e85b166', component.options)
    }
    module.hot.accept("./sendtypesetting.vue?vue&type=template&id=8e85b166", function () {
      api.rerender('8e85b166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/freightmanager/sendtypesetting.vue"
export default component.exports